<template>
  <div v-if="loading" class="overlay">
    <div class="spinner" :style="spinnerStyle"></div>
    <slot>{{ $t("products.loading") }}</slot>
  </div>
  <template v-else>
    <div class="bg-light product-page">
      <div class="container">
        <div class="section-header-breadcrumb">
          <h2 class="title-page">{{ $t("products.title") }}</h2>
        </div>

        <div class="product-list-page">
          
          <div class="content col-sm-12 col-md-12 col-lg-12 my-4">
            <ProductList />
          </div>
        </div>
      </div>
    </div>

    <div class="recommanded-block bg-light-1">
      <div class="product-list-recommanded container">
        <div class="row">
          <div class="content col-lg-12">
            <ProductRecommanded v-if="products_recommanded.length" :ProductsRec="products_recommanded" />
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white">
      <div class="service-list container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Service />
        </div>
      </div>
    </div>

    <div class="bg-light-1">
      <div class="question-list container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Question />
        </div>
      </div>
    </div>
  </template>
</template>

<script>
  import ProductList from "@/components/products/ProductList.vue";
  import ProductRecommanded from "@/components/products/ProductRecommanded.vue";
  import Service from "@/components/Service.vue";
  import Question from "@/components/Question.vue";
  import { useProductsStore } from "@/stores/productsStore";
  import { useRegisterStore } from "@/stores/register"; // Import registerStore

  export default {
    name: "ProductListPage",
    components: {
      ProductList,
      ProductRecommanded,
      Service,
      Question,
    },
    data() {
      return {
        productsStore: null,
        registerStore: null, // Add registerStore
        size: "50px",
        color: "#3498db",
      };
    },
    computed: {
      spinnerStyle() {
        return {
          width: this.size,
          height: this.size,
          borderColor: `${this.color} transparent transparent transparent`,
        };
      },
      products() {
        return this.productsStore.products;
      },
      products_recommanded() {
        return this.productsStore.allProducts;
      },
      loading() {
        return this.productsStore.loading;
      },
      error() {
        return this.productsStore.error;
      },
    },
    created() {
      this.productsStore = useProductsStore();
      this.registerStore = useRegisterStore(); // Initialize registerStore

      // Check if saved filters exist in registerStore
      if (
        this.$route.path === "/dashboard/products" &&
        this.registerStore.FilterProducts &&
        (this.registerStore.FilterProducts.filter_type_animal || this.registerStore.FilterProducts.order_by)
      ) {
        // Apply saved filters
        this.applySavedFilters();
      } else {
        // Fetch all products if no saved filters
        this.productsStore.fetchAllProducts();
      }
    },
    methods: {
      applySavedFilters() {
        const { filter_type_animal, filter_gamme, order_by } = this.registerStore.FilterProducts;
        let code = filter_gamme || filter_type_animal || "";
        let orderBy = "";

        // Map order_by to API-compatible format (same logic as in ProductList.vue)
        if (order_by) {
          switch (order_by) {
            case "AlphaAsc":
              orderBy = "order[translation.name]=asc";
              break;
            case "AlphaDesc":
              orderBy = "order[translation.name]=desc";
              break;
            case "PriceAsc":
              orderBy = "order[price]=asc";
              break;
            case "PriceDesc":
              orderBy = "order[price]=desc";
              break;
          }
        }

        const params = {
          page: 1, // Start at page 1
          itemsPerPage: 12, // Match ProductList.vue default
          orderBy,
        };

        // Fetch filtered products or all products with sorting
        if (code) {
          this.productsStore.fetchProductsByTaxon(code, params);
        } else {
          this.productsStore.fetchAllProducts(params);
        }
      },
    },
  };
</script>

<style scoped>
  .product-list-page {
    padding: 20px 0;
    text-align: center;
    max-width: 100%;
    .content {
      position: relative;
    }
  }
  .product-list-recommanded {
    padding: 30px;
    text-align: center;
    max-width: 100%;
  }

  .service-list {
    padding: 30px;
    text-align: center;
    max-width: 100%;
  }

  .question-list {
    padding: 40px;
    text-align: center;
    max-width: 100%;
  }

  .section-header-breadcrumb {
    text-align: left;
    font-style: normal;
    position: relative;
    .title-page {
      font-size: 30px;
      font-weight: bold;
      color: #1e347d;
    }
    label {
      font-size: 15px;
      font-weight: normal;
      span {
        color: #1e347d;
      }
    }
  }

  @media (max-width: 768px) {
    .product-list-page {
      padding: 15px;
    }
    .product-list-recommanded {
      padding-left: 120px;
      padding-right: 120px;
    }
  }

  .error,
  .empty {
    color: #777;
    font-size: 1.2em;
  }

  .error {
    color: red;
    font-weight: bold;
  }

  .empty {
    color: #888;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 1.2rem;
  }

  .spinner {
    border: 4px solid;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
